export default __webpack_public_path__ + "static/media/45.947120f9.jpeg";